const Style = {

  // ── Page header ───────────────────────────────────────────────────────────────
  pageTitle:        'text-2xl font-bold text-gray-900 m-0',
  pageSubtitle:     'text-gray-500 text-sm mt-1 mb-5',
  topBar:           'flex justify-between items-center mb-4',

  // ── Search ────────────────────────────────────────────────────────────────────
  searchWrap:       'relative w-[480px]',
  searchIcon:       'absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex',
  searchInput:      'w-full pl-[38px] pr-3 h-[37px] border border-gray-200 rounded-lg text-sm text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',

  // ── Filters button ────────────────────────────────────────────────────────────
  filterBtnWrap:    'relative',
  filterBtnBase:    'flex items-center gap-1.5 py-2 px-4 border rounded-lg text-sm cursor-pointer transition-colors',
  filterBtnActive:  'border-blue-600 bg-blue-50 text-blue-600',
  filterBtnInactive:'border-gray-200 bg-white text-gray-700',

  // ── Filter panel ──────────────────────────────────────────────────────────────
  filterPanel:      'absolute top-[calc(100%+8px)] right-0 z-[200] bg-white border border-gray-200 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] w-[300px] p-5',
  filterSection:    'mb-5',
  filterSectionLast:'mb-6',
  filterSectionLbl: 'text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em] mb-2',

  // License tier pill buttons
  tierChips:        'flex gap-1.5 flex-wrap',
  tierBtnBase:      'py-1 px-3.5 rounded-full text-[13px] font-medium cursor-pointer border transition-colors',
  tierBtnActive:    'border-blue-600 bg-blue-50 text-blue-600',
  tierBtnInactive:  'border-gray-200 bg-gray-100 text-gray-700',

  // Range inputs
  rangeWrap:        'flex gap-2 items-center',
  rangeInput:       'w-full h-8 px-2.5 border border-gray-200 rounded text-[13px] text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',
  rangeSeparator:   'text-gray-300 shrink-0',

  // Date range
  dateCol:          'flex flex-col gap-2',
  dateRow:          'flex items-center gap-2',
  dateFromToLabel:  'text-xs text-gray-400 w-7 shrink-0',
  dateInput:        'w-full h-8 px-2.5 border border-gray-200 rounded text-[13px] text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',

  // Panel footer
  filterFooter:     'flex items-center justify-between',
  filterClearBtn:   'bg-transparent border-none p-0 text-[13px] text-gray-500 cursor-pointer underline',
  filterApplyBtn:   'bg-blue-600 text-white border-none rounded-lg py-2 px-5 text-sm font-medium cursor-pointer hover:bg-blue-700',

  // ── Table cells (renderCell) ──────────────────────────────────────────────────
  cellName:         'px-4 h-[60px] font-medium text-gray-900 whitespace-nowrap',
  cellNameLink:     'text-inherit no-underline',
  cellEmail:        'px-4 h-[60px] text-gray-700',
  cellAccount:      'px-4 h-[60px] text-gray-700',
  cellAccountLink:  'text-blue-600 no-underline font-medium',
  cellDate:         'px-4 h-[60px] whitespace-nowrap',
  cellDateMain:     'text-gray-900',
  cellDateTime:     'text-gray-400 text-xs',
  cellLicense:      'px-4 h-[60px]',
  cellPractice:     'px-4 h-[60px] min-w-[160px]',
  cellNumber:       'px-4 h-[60px] text-gray-700 text-right',
  cellCenter:       'px-4 h-[60px] text-center',
  cellActions:      'px-4 h-[60px] relative',

  // ── Kebab menu ────────────────────────────────────────────────────────────────
  kebabBtn:         'bg-transparent border-none cursor-pointer text-gray-500 text-xl leading-none py-0.5 px-1.5 rounded hover:bg-gray-100',
  kebabMenu:        'absolute right-0 top-full z-[100] bg-white border border-gray-200 rounded-lg shadow-[0_4px_12px_rgba(0,0,0,0.1)] min-w-[140px]',
  kebabItem:        'block w-full py-2 px-4 bg-transparent border-none text-left text-sm cursor-pointer hover:bg-gray-50',
  kebabItemNormal:  'text-gray-700',
  kebabItemDanger:  'text-red-600',

};

export default Style;
